/* eslint-disable no-unused-vars */
import { array, bool, func, node, string } from "prop-types";
import React, { useEffect } from "react";
import { Button } from "..";

import "./modal.scss";

export const Modal = ({
	isVisible,
	onOk,
	onCancel,
	onClose,
	children,
	okText,
	cancelText,
	buttons,
	title = "",
	isLoading,
	disabled,
	onVisibleCallback,
}) => {
	useEffect(() => {
		if (isVisible && onVisibleCallback) {
			onVisibleCallback();
		}
	}, [isVisible]);
	return (
		<>
			{isVisible && (
				<div className="modal">
					<div className="modal__mask" onClick={onClose ? onClose : onCancel}></div>
					<div className="modal__body-wrapp">
						<div className="modal__content">
							{title && (
								<div className="modal__header">
									<div className="modal__title">{title}</div>
									{onClose && (
										<div className="modal__close-icon" onClick={onClose ? onClose : onCancel}>
											X
										</div>
									)}
								</div>
							)}

							<div className="modal__body">{children}</div>

							<div className="modal__footer">
								{!buttons && (
									<>
										{onCancel && (
											<Button
												text={cancelText ? cancelText : "Cancel"}
												className={"mr-20"}
												onClick={onCancel}
												type="bordered-azure"
											/>
										)}
										{onOk && (
											<Button
												text={okText ? okText : "OK"}
												onClick={onOk}
												type={"azure"}
												isLoading={isLoading}
												disabled={disabled}
											/>
										)}
									</>
								)}
								{buttons && buttons}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

Modal.propTypes = {
	isVisible: bool,
	onOk: func,
	onCancel: func,
	children: node,
	onClose: func,
	okText: string,
	cancelText: string,
	buttons: array,
	title: string,
	isLoading: bool,
	disabled: bool,
	onVisibleCallback: func,
};
